import React, {useContext, useEffect, useState} from "react";
import {getStatiKpiApi} from "../services/HomeServices";
import DashboardKpiStatiView from "./DashboardKpiStatiView";
import {AuthContext} from "../../../context/AuthContext";

export default function DashboardKpiStatiController() {

    const [loadingData, setLoadingData] = useState(true);
    const [info, setInfo] = useState([]);

    const {annoKpi} = useContext(AuthContext);

    async function getStatiKpi() {
        const response = await getStatiKpiApi();
        setInfo(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        if (annoKpi) {
            getStatiKpi();
        }
    }, [annoKpi]);

    return (
        /* Disegno solo se sono presenti dati */
        !loadingData && info && info.length > 0 &&
        <DashboardKpiStatiView
            info={info}
        />
    );
}